import { computed, inject } from '@angular/core';

import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { Default_Login_Page } from './default_login_page.constant';
import {
  ChatMessage,
  ChatMessageTypes,
  ComposedPage,
  CrossFrameMessage,
  CrossFrameMessageTypes,
} from '@hyper-inferno/survey-elements-core-utils';
import { ResponseRecord } from '@hyper-inferno/survey-elements-core';

export enum RenderStates {
  //   QUESTION = 'question',

  INITIALIZING = 'initializing',
  LOGIN = 'login',
  PAGE = 'page',

  LOADING = 'loading',
  ERROR_OCCURED = 'error',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'completed',
  END = 'end',
}

export interface RenderStatePayload {
  errorStatePayload?: {
    errorMessage: string;
  };
  endStatePayload?: {
    endMessage: string;
  };
  loadingPayload?: {
    watcher: any;
    globalTheme: {
      globalHeader: string;
      globalFooter: string;
    };
  };

  startConsentPayload?: {
    loginPage: string;
  };
}

export type QuestionState = {
  data: ResponseRecord; // The coerced ResponseRecord
  isValid: boolean;
  error: string | null;
  validate: () => boolean;
};

type APPState = {
  //   currentQuestionState: {
  //     question?: ComposedQuestion;
  //   };

  currentPageState: {
    page?: ComposedPage;
  };

  currentResponseState: {
    isValid: boolean;
    answerPayload: {
      answerObject: ResponseRecord;
    };
  };
  renderState: RenderStates;
  renderPayload: RenderStatePayload;
  pendingResolvers: Record<string, (value: any) => void>;
  registry: Record<string, QuestionState>;
  submitAttempted: number;
};

const initialState: APPState = {
  currentPageState: {
    page: undefined,
  },

  //   questionRenderDefinitions: [],
  currentResponseState: {
    answerPayload: {
      answerObject: {},
    },
    isValid: false,
  },
  renderState: RenderStates.INITIALIZING,
  renderPayload: {},
  pendingResolvers: {},
  registry: {} as Record<string, QuestionState>,
  submitAttempted: 0,
};

export const SurveyRenderControllerStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withComputed((store) => ({
    isPageValid: computed(() => {
      const states = Object.values(store.registry());
      return states.every((s) => s.isValid);
    }),
    // Flatten all data objects into the final payload for the Bot
    pageData: computed(() => {
      const registry = store.registry();
      return Object.values(registry).reduce(
        (acc, curr) => ({ ...acc, ...curr.data }),
        {},
      );
    }),
  })),

  withMethods((store) => ({
    receiveMessage(event: CrossFrameMessage): void {
      if (typeof event == 'string') {
        event = JSON.parse(event);
      }

      switch (event.type) {
        case CrossFrameMessageTypes.CONTROLLER_MESSAGE:
          if (event.chatMessage) this.handleChatMessage(event.chatMessage);
          break;
        case CrossFrameMessageTypes.CONTROLLER_RELOAD_COMMAND:
          location.reload();
          break;
        default:
          // console.log('Unhandled message from Controller', event);
          break;
      }
    },
    handleChatMessage(chatMessage: ChatMessage) {
      switch (chatMessage.messageType) {
        // case ChatMessageTypes.Question:
        //   this.setupCurrentQuestion(chatMessage.question);
        //   break;
        case ChatMessageTypes.Page:
          this.setupCurrentPage(chatMessage.page);
          break;
        case ChatMessageTypes.StartConsent:
          this.setRenderState(RenderStates.LOGIN, {
            startConsentPayload: {
              loginPage: chatMessage.message ?? Default_Login_Page,
            },
          });
          break;
        case ChatMessageTypes.EndSurvey:
          this.setRenderState(RenderStates.END, {
            endStatePayload: {
              endMessage: chatMessage.message ?? 'Thank you for your time',
            },
          });
          break;
        case ChatMessageTypes.BOT_ERROR:
          this.setRenderState(RenderStates.END, {
            endStatePayload: {
              endMessage: chatMessage.message ?? 'An Error has occured',
            },
          });
          break;

        case ChatMessageTypes.UNKNOWN:
          this.setRenderState(RenderStates.END, {
            endStatePayload: {
              endMessage: chatMessage.message ?? 'Unhandled Operation',
            },
          });
          break;
        default:
          break;
      }
    },

    setupCurrentPage(page: ComposedPage | undefined) {
      patchState(store, (state) => ({
        currentPageState: { page },
        registry: {},
        submitAttempted: 0,
      }));
      this.setRenderState(RenderStates.PAGE);
    },
    // setCurrentAnswerState(answer: {
    //   isValid: boolean;
    //   answerPayload: {
    //     answerObject: ResponseRecord;
    //     latlng?: any;
    //     pageTime?: any;
    //   };
    // }) {
    //   // Run schema Validation
    //   try {
    //     const coercedPayload = this.coerecedPayloadBuilders(
    //       answer.answerPayload.answerObject,
    //       store.currentQuestionState()?.question,
    //     );

    //     patchState(store, (state) => ({
    //       currentResponseState: {
    //         answerPayload: { answerObject: coercedPayload },
    //         isValid: answer.isValid,
    //       },
    //     }));

    //     this.updateSubmitedAsnwersState(coercedPayload);
    //   } catch (e) {
    //     throw new Error((e as Error)?.message);
    //   }
    // },
    setRenderState(
      renderState: RenderStates,
      renderPayload: RenderStatePayload = {},
    ) {
      patchState(store, (state) => ({
        renderState,
        renderPayload,
      }));
    },
    // coerecedPayloadBuilders(
    //   answerPayload: ResponseRecord,
    //   page: ComposedQuestion | any,
    // ) {
    //   return coerecedPayloadBuilder(answerPayload, question);
    //   // const ajvSchema = buildAjvSchema(questionMeta ?? {});
    //   // const ajv = new Ajv({ coerceTypes: true, useDefaults: true }); // Enable type coercion
    //   // // Compile the schema
    //   // const validate = ajv.compile(ajvSchema);
    //   // // Serialize form data (using jQuery)
    //   // const answerObjectSnap = { ...answerPayload };
    //   // // Validate and coerce the data
    //   // const valid = validate(answerObjectSnap);
    //   // if (valid) return answerObjectSnap as ResponseRecord;
    //   // else {
    //   //   throw new Error(
    //   //     `Validation Errors: \n ${printAjvErrors(validate.errors ?? [])}`
    //   //   );
    //   // }
    // },
    updateQuestionState(
      id: string,
      data: any,
      isValid: boolean,
      error: string | null = null,
      validate: () => boolean,
    ) {
      patchState(store, (state) => ({
        registry: {
          ...state.registry,
          [id]: { data, isValid, error, validate },
        },
      }));
    },
    attemptSubmit() {
      patchState(store, { submitAttempted: store.submitAttempted() + 1 });
    },
  })),
  withHooks({
    onInit(store) {},
    onDestroy(store) {},
  }),
);
